import React from 'react';
import '../../styles/global/EndText.scss';

const EndText = (props) => {
  return <div className="endText">{props.children}</div>;
};

export default EndText;
